import { Navigate, Outlet, useLocation } from 'react-router';

import { AppTopBar } from '@/app/layout/AppTopBar';
import { paths } from '@/app/routes/paths';
import { WORKSPACE_PAGE_GRADIENT } from '@/app/layout/constants';
import { resolveDefaultHomePath } from '@/features/auth/lib/default-home-path';
import { useAuthStore } from '@/store';

/**
 * Guardian portal shell: top navigation only (no sidebar).
 * Guardian-only users may only use guardian-portal routes.
 */
export function GuardianLayout() {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  const path = location.pathname;

  const guardianRouteAllowed =
    path === paths.guardianDashboard ||
    path.startsWith('/guardian/participant/');

  if (!guardianRouteAllowed) {
    return <Navigate to={paths.guardianDashboard} replace />;
  }

  return (
    <div
      className="flex h-dvh max-h-dvh w-full flex-col overflow-hidden"
      style={{ backgroundImage: WORKSPACE_PAGE_GRADIENT }}
    >
      <AppTopBar
        variant="guardian"
        userName={user?.fullName ?? ''}
        logoTo={user ? resolveDefaultHomePath(user) : paths.dashboard}
      />
      <main className="relative z-0 flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
